/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Execute_Output7Inputs */

const en_svc_mcp_server_development_execute_output7 = /** @type {(inputs: Svc_Mcp_Server_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working MCP server`)
};

const ar_svc_mcp_server_development_execute_output7 = /** @type {(inputs: Svc_Mcp_Server_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خادم MCP يعمل`)
};

const bn_svc_mcp_server_development_execute_output7 = /** @type {(inputs: Svc_Mcp_Server_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কার্যকর MCP সার্ভার`)
};

const de_svc_mcp_server_development_execute_output7 = /** @type {(inputs: Svc_Mcp_Server_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktionierender MCP-Server`)
};

const es_svc_mcp_server_development_execute_output7 = /** @type {(inputs: Svc_Mcp_Server_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servidor MCP funcional`)
};

const fr_svc_mcp_server_development_execute_output7 = /** @type {(inputs: Svc_Mcp_Server_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serveur MCP fonctionnel`)
};

const pt_svc_mcp_server_development_execute_output7 = /** @type {(inputs: Svc_Mcp_Server_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servidor MCP funcional`)
};

const zh_svc_mcp_server_development_execute_output7 = /** @type {(inputs: Svc_Mcp_Server_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可用的 MCP 服务器`)
};

const tr_svc_mcp_server_development_execute_output7 = /** @type {(inputs: Svc_Mcp_Server_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çalışan MCP sunucusu`)
};

const ru_svc_mcp_server_development_execute_output7 = /** @type {(inputs: Svc_Mcp_Server_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рабочий MCP-сервер`)
};

const pl_svc_mcp_server_development_execute_output7 = /** @type {(inputs: Svc_Mcp_Server_Development_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Działający serwer MCP`)
};

/**
* | output |
* | --- |
* | "Working MCP server" |
*
* @param {Svc_Mcp_Server_Development_Execute_Output7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_execute_output7 = /** @type {((inputs?: Svc_Mcp_Server_Development_Execute_Output7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Execute_Output7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_execute_output7(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_execute_output7(inputs)
	if (locale === "de") return de_svc_mcp_server_development_execute_output7(inputs)
	if (locale === "es") return es_svc_mcp_server_development_execute_output7(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_execute_output7(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_execute_output7(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_execute_output7(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_execute_output7(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_execute_output7(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_execute_output7(inputs)
	return en_svc_mcp_server_development_execute_output7(inputs)
});
export { svc_mcp_server_development_execute_output7 as "svc_mcp-server-development_EXECUTE_output" }